var map = {
	"./adder.png": 6673,
	"./and.png": 6222,
	"./buffer.png": 3507,
	"./decoder.png": 9393,
	"./divider.png": 3890,
	"./inverter.png": 2160,
	"./multiplexer.png": 4968,
	"./multiplier.png": 2536,
	"./nand.png": 7448,
	"./nor.png": 8303,
	"./or.png": 5514,
	"./subtractor.png": 3222,
	"./xor.png": 6206
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6466;